import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import "antd/dist/antd.css";
import Amplify, { Auth } from "aws-amplify";
import AwsConfig from "../../config/AwsConfig";
import {
  Card,
  Row,
  Col,
  Popover,
  Divider,
  Space,
  Spin,
  message,
  notification,
  Button,
  Modal,
  Drawer,
  Skeleton,
} from "antd";
import {
  HeartOutlined,
  FacebookOutlined,
  WhatsAppOutlined,
  TwitterOutlined,
  ShareAltOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  EyeOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import Layout from "antd/lib/layout/layout";
import NumberFormat from "react-number-format";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import axios from "axios";
import { withAppContext } from "../../store/contextStore";
import Mortgage from "../../common/Mortgage";
import MapScore from "../../common/MapScore";
import {
  add,
  noAuthadd,
  noAuthlist,
  noAuthgetDetails,
  list,
} from "../../api/Apis";
import SendMessage from "../../common/SendMessage";
import Advertisement from "../../common/Advertisement";
import DetailCarsouel from "../../containers/HomeSearch/Detail/DetailCarsouel";
import MapComponent from "../../common/MapComponent";
import BuyerAgentProfile from "../../components/Card/BuyerAgentCard";
import QuestionAnswers from "../../common/QuestionAnswers";
import Schedule from "../../common/Schedule";
import ImageGallery from "../../common/ImageGallery";
import HomesCarousel from "../../common/HomesCarousel";
import Loading from "../../common/Loading";
import bedIcon from "../../images/awesome-bed-icon.png";
import profilePic from "../../images/profileAvatar.png";
import bathIcon from "../../images/awesome-bath-icon.png";
import reSize from "../../images/sq-feet-icon.png";
import SignupForm from "../../containers/RegisterForm";
import LoginForm from "../../containers/LoginForm";
import VedioLink from "../../images/vediolink.png";
import DegreeLink360 from "../../images/DegreeLink.png";
import DeleteRecord from "../../common/DeleteRecord";
import { computeMatchScore } from "../../utils/buyerMatchScore";
import { MatchScoreBanner } from "../../common/MatchScoreBadge";
import BuyerProfileModal from "../../common/BuyerProfileModal";

Amplify.configure(AwsConfig);

export class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: "",
      longitude: "",
      country: "USA",
      enableSignupForm: false,
      agentsVisible: false,
      agentsList: [],
      contactAgentList: [],
      zipCode: "",
      loginUserInfo: "",
      validUser: false,
      properties: "",
      buyerHomeList: "",
      userProfile: "",
      homesData: [],
      similarHomesList: [],
      singleData: {},
      currentIndex: "",
      isPopup: false,
      beforeLoginLoading: false,
      favoritesFilterData: {},
      propertyDetailsId: "",
      setPropertyDetails: false,
      showSendMessagePopUp: false,
      openHouseReserve: false,
      setMlsVendor: "",
      homeDetailShareUrl: "",
      matchScore: null,
      aiAnalysisLoading: false,
      aiAnalysisResult: null,
      showBuyerProfileModal: false,
    };
  }

  componentDidMount = () => {
    this.init();
    this.getIpAddress();
    this.homeAnalytics("view");
  };

  init = () => {
    this.setState({
      beforeLoginLoading: true,
      latitude: "",
    });
    this.getAllUsers();
    this.getLoginUserInfo();
    this.getAllRecords();
    this.getUserDetails(this.props.match.params.id);
    const { isPopup, propertyId, stateType } = this.props;
    var propertyIdValue = "";
    var stateNameValue = "";
    if (isPopup && isPopup === true) {
      propertyIdValue = propertyId;
      stateNameValue = stateType;
      this.setState({ isPopup: true });
    } else {
      propertyIdValue = this.props.match.params.id;
      stateNameValue = this.props.match.params.stateName;
    }
    if (stateNameValue === "offMls") {
      var detailsObjOff = { isMls: false };
      this.setState({
        favoritesFilterData: detailsObjOff,
        propertyDetailsId: propertyIdValue,
        propertyMlsType: "offMls",
      });
      this.handlePropertyDetails(propertyIdValue, detailsObjOff);
    } else {
      var stateCodes = JSON.parse(localStorage.getItem("stateCodesFromAdmin"));
      if (stateCodes && stateCodes.length > 0) {
        var setVendor = stateCodes.filter(
          function(restState) {
            return restState.stateName.toLowerCase() === stateNameValue.toLowerCase() ||
              restState.stateType.toLowerCase() === stateNameValue.toLowerCase();
          }
        );
        var vendor = setVendor && setVendor[0].vendorType;
        var detailsObjMls = { isMls: true, vendor: vendor };
        this.setState({
          favoritesFilterData: detailsObjMls,
          propertyDetailsId: propertyIdValue,
          propertyMlsType: "mls",
          setMlsVendor: vendor,
        });
        this.handlePropertyDetails(propertyIdValue, detailsObjMls, "mls");
      }
    }
  };

  getIpAddress = () => {
    axios
      .get(process.env.REACT_APP_IPADDRESS)
      .then(function(result) { this.addIpAddress(result.data); }.bind(this))
      .catch(function(error) { console.log("Error :", error); });
  };

  addIpAddress = async (data) => {
    var payload = { entityData: data };
    try {
      await noAuthadd("ipAddressAnalytics", payload);
    } catch (error) {
      console.log("Error :", error);
    }
  };

  homeAnalytics = async (type, isFav) => {
    var listingId = this.props.match.params.id;
    var viewData = { entityData: { listingId: listingId, listingViews: true } };
    var favData = { entityData: { listingId: listingId, listingFavorites: isFav ? true : false } };
    var postData = type === "view" ? viewData : favData;
    try {
      var response = await noAuthadd("homesAnalytics", postData);
      console.log(response);
    } catch (error) {
      console.log("Error :", error);
    }
  };

  getAllRecords = async () => {
    this.setState({ currentIndex: "" });
    var filterData = JSON.parse(localStorage.getItem("filterSearchData"));
    if (
      window.location.pathname !== "/buyersHome/" + this.props.match.params.id &&
      this.props.location &&
      this.props.location.state &&
      !this.props.location.state.agentPage
    ) {
      var HomesListData = await noAuthlist("getHomesList", filterData);
      try {
        if (HomesListData.success) {
          this.setState({ homesData: HomesListData.data });
          this.getCurrentIndex(HomesListData.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  getCurrentIndex = (totalRecords) => {
    var currentIndexValue = totalRecords.findIndex(function(item) {
      return String(item.openHouseKey ? item.openHouseKey : item.id) === this.props.match.params.id;
    }.bind(this));
    this.setState({ currentIndex: currentIndexValue, beforeLoginLoading: false });
  };

  handleNext = async (pageType) => {
    var currentIndex = this.state.currentIndex;
    var homesData = this.state.homesData;
    var currentIndexValue = currentIndex;
    if (pageType === "Next") {
      currentIndexValue = currentIndex + 1;
    } else {
      currentIndexValue = currentIndex - 1;
    }
    this.setState({ currentIndex: currentIndexValue, showSendMessagePopUp: false });
    var requiredItem = homesData[currentIndexValue];
    this.props.history.push(
      "/homeDetails/" + requiredItem.stateName + "/" + (requiredItem.openHouseKey ? requiredItem.openHouseKey : requiredItem.id),
      true
    );
    this.setState({ beforeLoginLoading: true });
    setTimeout(function() {
      this.setState({ loginUserInfo: "" });
      this.init();
    }.bind(this), 2000);
  };

  handlePropertyDetails = async (propertyId, detailsObj, mlsType) => {
    try {
      var userLogin = localStorage.getItem("userLogin");
      var response = {};
      if (userLogin) {
        var authResults = await list("getPropertyDetails/" + propertyId + "?", detailsObj);
        if (authResults.success) { response = authResults; }
      } else {
        var noAuthResults = await noAuthlist("getPropertyDetails/" + propertyId + "?", detailsObj);
        if (noAuthResults.success) { response = noAuthResults; }
      }
      if (response.success && mlsType !== "mls") {
        var photos = [];
        for (var o of response.data && response.data.homePhotos && response.data.homePhotos) {
          var newImage2 = "https://" + process.env.REACT_APP_S3_BUCKET + ".s3.amazonaws.com/public/" + o;
          photos.push(newImage2);
        }
        response.data["photos"] = photos;
        this.setState({
          singleData: response.data,
          beforeLoginLoading: false,
          setPropertyDetails: true,
        });
        this.computeMatchScoreForListing(response.data);
        setTimeout(function() {
          if (response.data && response.data.address && response.data.address[0]) {
            this.getFormattedAddress(response.data.address[0]);
          }
        }.bind(this), 5000);
      } else {
        if (response.success) {
          response.data["photos"] = response.data && response.data.homePhotos && response.data.homePhotos.length > 0
            ? response.data.homePhotos : [];
          this.setState({
            singleData: response.data,
            beforeLoginLoading: false,
            setPropertyDetails: true,
          });
          this.computeMatchScoreForListing(response.data);
          setTimeout(function() {
            if (response.data && response.data.title) {
              this.getFormattedAddress(response.data.title);
            }
          }.bind(this), 5000);
        }
      }
      if (response.success) {
        if (!response.data.favorites) {
          this.clearNotificationApi = setInterval(function() {
            notification["info"]({
              message: "Click here to favorite property.",
              btn: (
                <Button
                  type="primary"
                  size="small"
                  onClick={function() { this.handleFavorites(response.data); }.bind(this)}
                  style={{ width: "124px", height: "30px" }}
                >
                  Add to Favorites
                </Button>
              ),
            });
          }.bind(this), 60000);
          setInterval(function() {
            clearInterval(this.clearNotificationApi);
          }.bind(this), 70000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  componentWillUnmount() {
    clearInterval(this.clearNotificationApi);
  }

  computeMatchScoreForListing = (listingData) => {
    var buyerProfile = this.props.context.state.buyerHomeDetails;
    if (!buyerProfile || !buyerProfile.buyerPropertyDetails) return;
    var latitude = this.state.latitude;
    var longitude = this.state.longitude;
    var listingCoords = latitude && longitude ? { lat: latitude, lng: longitude } : null;
    var score = computeMatchScore(listingData, buyerProfile, {
      listingCoords: listingCoords,
      includeLifeAddresses: true,
    });
    this.setState({ matchScore: score });
  };

  getAIAnalysis = async () => {
    var singleData = this.state.singleData;
    var matchScore = this.state.matchScore;
    var buyerProfile = this.props.context.state.buyerHomeDetails;
    if (!singleData) return;

    var localUD = JSON.parse(localStorage.getItem("userDetails") || "{}");
    var lifestyleBP = localUD.buyerProfile || {};

    this.setState({ aiAnalysisLoading: true });
    try {
      var propDetails = (buyerProfile && buyerProfile.buyerPropertyDetails) || {};
      var propFeatures = (buyerProfile && buyerProfile.buyerPropertyFeatures) || {};

      // Merge lifestyle profile data from BuyerProfileModal
      var lifeAddrList = [
        ...(propDetails.lifeAddresses || []),
        ...(lifestyleBP.lifeAddresses || []),
      ].map(function(a) {
        return (a.label || a.type) + " (" + a.type + ", " + (a.maxCommuteMiles || 30) + "mi max)";
      }).join("; ");

      var townsList = [
        ...(propDetails.updatedInterestedTowns || []).map(function(t) { return t.cityName + ", " + t.stateName; }),
        ...(lifestyleBP.targetCities || []),
      ].join("; ");
      var prompt = "You are a real estate AI assistant for My Home Buddha. A buyer is viewing a specific listing and wants to know how well it matches their life beyond just the house criteria.\n\nLISTING:\n- Address: " + (singleData.title || singleData.address || "Unknown") + "\n- Price: $" + ((singleData.OriginalListprice || singleData.cost || 0).toLocaleString()) + "\n- Beds: " + singleData.beds + " | Baths: " + singleData.baths + "\n- Type: " + (singleData.PropertyType || singleData.type || "N/A") + "\n- City: " + (singleData.city || "N/A") + ", " + (singleData.state || "") + "\n- Description: " + (singleData.description || "No description provided") + "\n- Year Built: " + (singleData.YearBuilt || "N/A") + "\n\nBUYER PROFILE:\n- Looking for: " + (propDetails.title || lifestyleBP.lifeStage || "A new home") + "\n- Budget: $" + ((propDetails.minprice || lifestyleBP.priceMin || 0).toLocaleString()) + " to $" + ((propDetails.maxprice || lifestyleBP.priceMax || 0).toLocaleString()) + "\n- Needs: " + (propFeatures.minbeds || propFeatures.beds || "any") + " beds, " + (propFeatures.minbaths || propFeatures.baths || "any") + " baths\n- Preferred towns: " + (townsList || "Not specified") + "\n- Timeline: " + (propDetails.timeFrame || lifestyleBP.timeline || "Not specified") + "\n- Life stage: " + (lifestyleBP.lifeStage || "Not specified") + "\n- Hobbies & interests: " + ((lifestyleBP.hobbies || []).join(", ") || "Not specified") + "\n- Neighborhood vibe: " + ((lifestyleBP.neighborhoodVibes || []).join(", ") || "Not specified") + "\n- Must haves: " + ((lifestyleBP.mustHaves || []).join(", ") || propDetails.description || "None specified") + "\n- Deal breakers: " + ((lifestyleBP.dealBreakers || []).join(", ") || "None specified") + "\n- Work from home: " + (lifestyleBP.workFromHome || "Not specified") + "\n- Household: " + (lifestyleBP.householdSize || "Not specified") + " people, kids: " + (lifestyleBP.hasKids ? "yes" : "no") + ", pets: " + (lifestyleBP.hasPets ? "yes" : "no") + "\n- Life addresses (commute needs): " + (lifeAddrList || "None added") + "\n- Additional notes: " + (lifestyleBP.additionalNotes || propDetails.description || "None") + "\n\nHOUSE CRITERIA MATCH SCORE: " + (matchScore ? matchScore.tier1 + "/70" : "N/A") + "\nLIFE ADDRESS MATCH SCORE: " + (matchScore ? matchScore.tier2 + "/20" : "N/A") + "\n\nWrite a warm, conversational 3-4 sentence analysis explaining how well this home fits this buyer's life. Reference specific lifestyle details they shared (hobbies, family situation, deal breakers). Be honest about mismatches with their preferred towns or budget. End with one key reason to visit or one key concern. Keep it under 130 words.";

      var fetchResponse = await fetch("https://ai.myhomebuddha.com/.netlify/functions/claude", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-haiku-4-5-20251001",
          max_tokens: 200,
          messages: [{ role: "user", content: prompt }],
        }),
      });
      var data = await fetchResponse.json();
      var text = data.content && data.content[0] && data.content[0].text;
      this.setState({ aiAnalysisResult: text, aiAnalysisLoading: false });
    } catch (err) {
      console.error("AI analysis failed:", err);
      this.setState({ aiAnalysisLoading: false });
    }
  };

  getUserDetails = async (id) => {
    var UserInfo = await noAuthgetDetails("getAgents", id);
    if (UserInfo.success) {
      this.setState({ userProfile: UserInfo.data });
    }
  };

  handleBack = () => {
    if (window.location.pathname.includes("/buyersHome") && this.props.location.state === true) {
      this.props.history.push("/buyers");
    } else {
      if (this.props.location.state && this.props.location.state.favorited) {
        this.props.history.goBack();
      } else if (
        (this.props.location.state && this.props.location.state.agentPage) ||
        this.props.location.state === false
      ) {
        this.props.history.goBack();
      } else {
        if (this.props.match.params.stateName === "offMls") {
          this.props.history.push("/offMLSHomes");
        } else {
          this.props.history.push("/homes");
        }
      }
    }
  };

  getFormattedAddress = async (address) => {
    await geocodeByAddress(address)
      .then(function(results) { return getLatLng(results[0]); })
      .then(function(latLng) {
        this.setState({
          latitude: latLng.lat,
          longitude: latLng.lng,
          beforeLoginLoading: false,
        });
        this.computeMatchScoreForListing(this.state.singleData);
      }.bind(this));
  };

  getLoginUserInfo = async () => {
    var loginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (loginUserDetails && loginUserDetails.id) {
      var loginUserId = loginUserDetails.id;
      var loginUserName = loginUserDetails.firstName + " " + loginUserDetails.lastName;
      var userInfo = {
        userId: loginUserId,
        userName: loginUserName,
        userProfile: loginUserDetails.userProfile,
        preferedAgent: loginUserDetails.agentInfo && loginUserDetails.agentInfo.agentEmail,
        prefereAgentName: loginUserDetails.agentInfo && loginUserDetails.agentInfo.agentName,
      };
      this.setState({ loginUserInfo: userInfo, showSendMessagePopUp: true });
      if (this.props && this.props.singleData && this.props.singleData.userId) {
        if (loginUserId === this.props.singleData.userId) {
          this.setState({ validUser: true });
        }
      }
      // Fetch and load buyer profile for buyer/seller accounts so match
      // scoring works on the detail page without requiring a prior visit to search
      var accountType = loginUserDetails.userProfile;
      if (accountType === "B" || accountType === "S") {
        this.fetchAndSetBuyerProfileForDetails(loginUserId);
      }
    } else {
      this.setState({ showSendMessagePopUp: true });
    }
  };

  getAllUsers = async () => {
    try {
      var allUsers = await noAuthlist("getAgents");
      var filteredClientAgent = allUsers.data.length > 0
        ? allUsers.data.filter(function(agent) { return agent.email === process.env.REACT_APP_CLIENT_AGENT_EMAIL; })
        : [];
      var clientAgentsDetails = [];
      if (filteredClientAgent) {
        for (var i = 0; i < filteredClientAgent.length; i++) {
          var singleItemC = filteredClientAgent[i];
          if (singleItemC.profilePicture) {
            singleItemC["AgnetProfileUrl"] = "https://" + process.env.REACT_APP_S3_BUCKET + ".s3.amazonaws.com/public/" + singleItemC.profilePicture[0];
          } else {
            singleItemC["AgnetProfileUrl"] = "";
          }
          clientAgentsDetails.push(Object.assign({}, singleItemC));
        }
        this.setState({ contactAgentList: clientAgentsDetails });
      }
      var allFilterAgents = allUsers.data.filter(function(o) {
        return o.subscriptionPack && o.subscriptionPack.premierStatus === "Y" && o.email !== process.env.REACT_APP_CLIENT_AGENT_EMAIL;
      });
      var FilterAgents = allFilterAgents.sort(function(a, b) {
        return parseInt(a.subscriptionPack.price) > parseInt(b.subscriptionPack.price) ? -1 : 1;
      });
      var AgentsDetails = [];
      if (FilterAgents) {
        for (var j = 0; j < FilterAgents.length; j++) {
          var singleItemA = FilterAgents[j];
          if (singleItemA.profilePicture) {
            singleItemA["AgnetProfileUrl"] = "https://" + process.env.REACT_APP_S3_BUCKET + ".s3.amazonaws.com/public/" + singleItemA.profilePicture[0];
          } else {
            singleItemA["AgnetProfileUrl"] = "";
          }
          AgentsDetails.push(Object.assign({}, singleItemA));
        }
        this.setState({ agentsList: AgentsDetails });
      }
    } catch (error) {
      alert("Something went wrong...");
    }
  };

  handleFavorites = async (singleData) => {
    var userDetails = JSON.parse(localStorage.getItem("userDetails"));
    var userLogin = localStorage.getItem("userLogin");
    if (userLogin) {
      var data = Object.assign({}, {
        entityData: {
          userId: userDetails.id,
          leadId: singleData && singleData.homeId,
          data: singleData,
          mls: this.props.match.params.stateName === "offMls" ? false : true,
          date: singleData && singleData.createdAt ? moment(singleData.createdAt).format("MMM Do YYYY") : "",
          stateType: this.props && this.props.match && this.props.match.params && this.props.match.params.stateName,
          price: singleData && singleData.OriginalListprice ? singleData.OriginalListprice : singleData.minPrice !== null ? singleData.minPrice : 0,
          leadStatus: singleData && singleData.status,
        },
      });
      try {
        var postFavorites = await add("userFavorites", data);
        if (postFavorites.success) {
          message.success(
            <span>Listing added to favorites.<br />Click on the heart symbol in the top menu to see your favorite listings</span>
          );
          this.handlePropertyDetails(this.state.propertyDetailsId, this.state.favoritesFilterData, this.state.propertyMlsType);
          this.homeAnalytics("fav", true);
        }
      } catch (error) {
        alert("Something went wrong....");
      }
    } else {
      this.openNotification();
    }
  };

  handleDetailsAfterDeleteFav = async () => {
    await this.setState({ deleteFavoriteData: [], dataLoading: false });
    this.handlePropertyDetails(this.state.propertyDetailsId, this.state.favoritesFilterData, this.state.propertyMlsType);
    this.homeAnalytics("fav", false);
  };

  shareThisHome = (e) => {
    var stateName = this.props.match.params.stateName;
    var shareUrl = process.env.REACT_APP_API_GATEWAY + "/noAuth/getHomes/" + e + "/" + stateName;
    var homeDetailShareUrl = process.env.REACT_APP_BASE_URL + "homeDetails/" + stateName + "/" + e;
    this.setState({ shareUrl: shareUrl, homeDetailShareUrl: homeDetailShareUrl });
  };

  openNotification = () => {
    notification.info({
      placement: "topLeft",
      message: "Please create your free account today to save your favorite listings and be notified of new listings",
      style: { fontWeight: "500" },
    });
    this.setState({ enableSignupForm: true });
  };

  handleonCancel = () => { this.setState({ enableSignupForm: false }); };
  handleToshowLoginSider = () => { this.setState({ showLoginSiderForm: true }); };
  handletoShowSignupsider = () => { this.setState({ showLoginSiderForm: false }); };
  handleReset = () => { this.setState({ enableSignupForm: false }); };
  handle_to_copy_property_url = () => { notification["success"]({ message: "Link copied to clipboard" }); };
fetchAndSetBuyerProfileForDetails = async (userId) => {
    try {
      var apiBase = process.env.REACT_APP_API_GATEWAY || "https://2uz1znno9a.execute-api.us-east-1.amazonaws.com/prod";
      var response = await fetch(apiBase + "/noAuth/getMyBuyerProfiles?userId=" + userId);
      var json = await response.json();
      // Also check localStorage lifestyle profile
      var localUD = JSON.parse(localStorage.getItem("userDetails") || "{}");
      if (localUD.buyerProfile && (localUD.buyerProfileCompleted || localUD.buyerProfileStarted)) {
        var bp = localUD.buyerProfile;
        var lifestyleForDetails = {
          buyerPropertyDetails: {
            minprice: bp.priceMin && bp.priceMin !== "" ? parseInt(bp.priceMin) : null,
            maxprice: bp.priceMax && bp.priceMax !== "" ? parseInt(bp.priceMax) : null,
            propertyType: bp.propertyTypes || null,
            updatedInterestedTowns: (bp.targetCities || []).map(function(c) {
              return { cityName: c, stateName: "MA", locationType: "location" };
            }),
            lifeAddresses: bp.workAddress ? [{ label: bp.workAddress, type: "work", maxCommuteMiles: Math.round((bp.maxCommuteMins || 30) * 0.5) }] : [],
          },
          buyerPropertyFeatures: {
            beds: bp.minBeds > 0 ? parseInt(bp.minBeds) : null,
            baths: bp.minBaths > 0 ? parseInt(bp.minBaths) : null,
            minbeds: bp.minBeds > 0 ? parseInt(bp.minBeds) : null,
            minbaths: bp.minBaths > 0 ? parseInt(bp.minBaths) : null,
          },
        };
        this.props.context.setBuyerHomeDetails(lifestyleForDetails.buyerPropertyDetails, "BUYER_PROPERTY_DETAILS");
        this.props.context.setBuyerHomeDetails(lifestyleForDetails.buyerPropertyFeatures, "BUYER_PROPERTY_FEATURES");
        this.computeMatchScoreForListing(this.state.singleData);
      }
      if (json.data && json.data.length > 0) {
        // Pick most complete profile
        var primary = json.data.find(function(p) {
          return p.buyerPropertyDetails && (
            p.buyerPropertyDetails.minprice ||
            p.buyerPropertyDetails.maxprice ||
            (p.buyerPropertyDetails.updatedInterestedTowns && p.buyerPropertyDetails.updatedInterestedTowns.length > 0)
          );
        }) || json.data[0];
 
        if (primary.buyerPropertyDetails) {
          this.props.context.setBuyerHomeDetails(primary.buyerPropertyDetails, "BUYER_PROPERTY_DETAILS");
        }
        if (primary.buyerPropertyFeatures) {
          this.props.context.setBuyerHomeDetails(primary.buyerPropertyFeatures, "BUYER_PROPERTY_FEATURES");
        }
        if (primary.buyerPrivateDetails) {
          this.props.context.setBuyerHomeDetails(primary.buyerPrivateDetails, "BUYER_PRIVATE_DETAILS");
        }
        if (primary.buyerPropertyDetails2) {
          this.props.context.setBuyerHomeDetails(primary.buyerPropertyDetails2, "BUYER_PROPERTY_DETAILS2");
        }

        // Score directly using the fetched profile — don't read from context
        // since setState is async and context won't have updated yet
        var flatProfile = Object.assign(
  {},
  primary,
  primary.buyerPropertyDetails || {},
  primary.buyerPropertyFeatures || {},
  primary.buyerPropertyDetails2 || {},
  primary.buyerPrivateDetails || {}
);
var directScore = computeMatchScore(
  this.state.singleData,
  flatProfile,
  {
    listingCoords: this.state.latitude && this.state.longitude
      ? { lat: this.state.latitude, lng: this.state.longitude }
      : null,
    includeLifeAddresses: true,
  }
);
        if (directScore && directScore.hasBuyerProfile) {
          this.setState({ matchScore: directScore });
        }
      }
    } catch (err) {
      console.log("fetchAndSetBuyerProfileForDetails error:", err);
    }
  };
  handleOpenBuyerProfileModal = () => {
    this.setState({ showBuyerProfileModal: true });
  };

  handleBuyerProfileModalComplete = () => {
    this.setState({ showBuyerProfileModal: false });
    // Re-fetch profile and rescore
    var userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
    if (userDetails.id) {
      this.fetchAndSetBuyerProfileForDetails(userDetails.id);
    }
  };
  render() {
    var stateVars = this.state;
    var agentsList = stateVars.agentsList;
    var contactAgentList = stateVars.contactAgentList;
    var loginUserInfo = stateVars.loginUserInfo;
    var agentsVisible = stateVars.agentsVisible;
    var showLoginSiderForm = stateVars.showLoginSiderForm;
    var userProfile = stateVars.userProfile;
    var latitude = stateVars.latitude;
    var longitude = stateVars.longitude;
    var dataLoading = stateVars.dataLoading;
    var homesData = stateVars.homesData;
    var singleData = stateVars.singleData;
    var beforeLoginLoading = stateVars.beforeLoginLoading;
    var isPopup = stateVars.isPopup;
    var showSendMessagePopUp = stateVars.showSendMessagePopUp;
    var homeDetailShareUrl = stateVars.homeDetailShareUrl;
    var shareUrl = stateVars.shareUrl;
    var matchScore = stateVars.matchScore;
    var aiAnalysisLoading = stateVars.aiAnalysisLoading;
    var aiAnalysisResult = stateVars.aiAnalysisResult;

    var paramsState = this.props && this.props.match && this.props.match.params && this.props.match.params.stateName;
    var card_content = [];
    singleData &&
      card_content.push(
        singleData && singleData.OriginalListprice
          ? {
              name: "List Price",
              value: singleData && singleData.OriginalListprice && (
                <NumberFormat value={parseFloat(singleData.OriginalListprice).toFixed(2)} displayType={"text"} thousandSeparator={true} prefix={"$"} />
              ),
            }
          : {
              name: "Price Range",
              value: (
                <div>
                  <NumberFormat value={singleData.minPrice} displayType={"text"} thousandSeparator={true} prefix={"$"} />{" "}-{" "}
                  <NumberFormat value={singleData.maxPrice} displayType={"text"} thousandSeparator={true} prefix={"$"} />
                </div>
              ),
            },
        { name: "Refered Agent", value: singleData && singleData.referedAgentName && singleData.referedAgentName },
        { name: "Features", value: singleData && singleData.Features && singleData.Features !== false ? singleData.Features : "" },
        { name: "Living area", value: "" + (singleData.area ? singleData.area : "--") },
        { name: "Beds", value: singleData.beds },
        { name: "Bath", value: singleData.baths },
        { name: "Half bath", value: singleData.halfBaths },
        { name: "Rooms", value: singleData.rooms },
        { name: "Style", value: singleData.HomeStyle },
        { name: "Cooling", value: singleData.colling },
        { name: "Heating", value: singleData && singleData.heating !== "" ? singleData.heating : "" },
        { name: "Fireplaces", value: singleData && singleData.fireplaces && singleData.fireplaces !== "" && singleData.fireplaces >= 1 ? "Yes" : "No" },
        { name: "Flooring", value: singleData.flooring },
        { name: "Interior Features", value: singleData && singleData.interiorFeatures !== "" ? singleData.interiorFeatures : "" },
        { name: "Lot Description", value: singleData.lotDescription },
        { name: "Year Built", value: singleData && singleData.YearBuilt },
        { name: "Exterior", value: singleData && singleData.Exterior !== "" ? singleData.Exterior : "" },
        { name: "Parking Spaces", value: singleData.ParkingSpaces },
        { name: "Garage Spaces", value: singleData.GarageSpaces },
        { name: "Lot size", value: singleData && singleData.lotSize && singleData.lotSize.length > 0 ? singleData.lotSize : "" },
        { name: "Basement", value: singleData && singleData.basement !== "" ? singleData.basement : "" },
        { name: "Condition", value: singleData.condition },
        { name: "Dwelling", value: singleData.dwelling },
        { name: "Utilities", value: singleData && singleData.utilities !== "" ? singleData.utilities : "" },
        { name: "Property Type", value: singleData.PropertyType }
      );

    var content = (
      <div>
        <div className="share-to-social-media">
          <a target="_blank" onClick={function() { window.FB.ui({ display: "popup", method: "share", href: shareUrl }, function(response) {}); }} href={function() { return false; }} rel="noreferrer" style={{ textDecoration: "none" }}>
            <FacebookOutlined style={{ fontSize: 18 }} />&nbsp;&nbsp; facebook
          </a>
        </div>
        <div className="share-to-social-media">
          <a target="_blank" rel="noreferrer" href={"https://api.whatsapp.com/send?text= " + homeDetailShareUrl} style={{ textDecoration: "none" }}>
            <WhatsAppOutlined style={{ fontSize: 18 }} />&nbsp;&nbsp; Whatsapp
          </a>
        </div>
        <div className="share-to-social-media">
          <a target="_blank" href={"https://twitter.com/intent/tweet?text=" + homeDetailShareUrl} rel="noreferrer" style={{ textDecoration: "none" }}>
            <TwitterOutlined style={{ fontSize: 18 }} /> &nbsp;&nbsp; Twitter
          </a>
        </div>
        <div className="share-to-social-media">
          <CopyToClipboard text={homeDetailShareUrl} onCopy={this.handle_to_copy_property_url}>
            <span style={{ color: "#1890ff" }}><CopyOutlined />&nbsp;&nbsp;&nbsp;Copy URL</span>
          </CopyToClipboard>
        </div>
      </div>
    );

    var userDetails = {
      homeAgentName: userProfile && userProfile.firstName + " " + userProfile.lastName,
      profileURL: userProfile && userProfile.profilePicture
        ? "https://" + process.env.REACT_APP_S3_BUCKET + ".s3.amazonaws.com/public/" + userProfile.profilePicture[0] : "",
      userId: userProfile && userProfile.id,
      mlsId: userProfile && userProfile.mlsId,
      agentEmail: userProfile && userProfile.email,
      companyName: userProfile && userProfile.newdata && userProfile.newdata.companyName,
      userType: userProfile && userProfile.userProfile,
    };

    var details_data = [];
    details_data.push(
      { name: "Date and Time Added", value: moment(singleData && singleData.createdAt).format("D  MMMM, YYYY") },
      { name: singleData && singleData.mlsData && "MLS ID", value: singleData && singleData.mlsData && singleData.homeId ? singleData.homeId : " " },
      {
        name: "Status",
        value: singleData && singleData.status && typeof singleData.status === "object"
          ? singleData.status.includes("pending") && singleData.status.includes("activeundercontract") ? "Under Agreement"
            : singleData.status.includes("comingsoon") ? "Coming Soon"
            : singleData.status.includes("active") ? "New Listing"
            : singleData.status
          : singleData.status,
      },
      { name: "Area", value: "" },
      { name: "Year Built", value: singleData && singleData.YearBuilt },
      { name: "Cooperating Commission", value: singleData && singleData.corporationCommission && singleData.corporationCommission + "%" }
    );

    var userLogin = localStorage.getItem("userLogin");

    return (
      <>
        {beforeLoginLoading ? (
          <Loading enableLoading={beforeLoginLoading} />
        ) : (
          <>
            <div>
              <Layout style={{ marginTop: "1vw" }}>
                <Row>
                  {isPopup !== true && (
                    <Col span={17} style={{ marginTop: "10px", marginBottom: "10px" }} className="margin-body-agent">
                      <Button type="text" icon={<ArrowLeftOutlined />} className="font-family-style font-medium-size" onClick={this.handleBack}>
                        {this.props.location.state && this.props.location.state.favorited && this.props.location.state.favorited
                          ? "Back to favorites"
                          : this.props.location.state && this.props.location.state.agentPage && this.props.location.state.agentPage
                          ? "Back to agent search"
                          : this.props.location.state === false
                          ? "Go Back"
                          : "Return to search result"}
                      </Button>
                    </Col>
                  )}
                  {this.state.setPropertyDetails && (
                    <Col span={24}>
                      <div>
                        <Layout className="margin-body-agent">
                          <Row>
                            {this.state.currentIndex !== "" && this.props.location.state && this.props.location.state === true && this.props.location.state !== undefined && (
                              <Col xl={{ span: 24, offset: 0 }} lg={{ span: 24, offset: 0 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                {isPopup !== true && (
                                  <Row justify="space-between">
                                    <Col>
                                      {this.state.currentIndex !== 0 && (
                                        <Button type="primary" className="font-family-style font-medium-size" onClick={function() { this.handleNext("Previous"); }.bind(this)}>
                                          <Row><Col><ArrowLeftOutlined /></Col><Col className="Next-Search-font">Prev</Col></Row>
                                        </Button>
                                      )}
                                    </Col>
                                    <Col className="margin-body-agent-right">
                                      {homesData && homesData.length === this.state.currentIndex + 1 ? "" : (
                                        <Button type="primary" className="font-family-style font-medium-size" onClick={function() { this.handleNext("Next"); }.bind(this)} style={{ float: "right" }}>
                                          <Row><Col className="Next-Search-font">Next</Col><Col><ArrowRightOutlined /></Col></Row>
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>
                                )}
                              </Col>
                            )}
                            <Col xl={{ span: isPopup !== true ? 17 : 24, offset: 0 }} lg={{ span: isPopup !== true ? 17 : 24, offset: 0 }} md={{ span: isPopup !== true ? 22 : 24, offset: 1 }} sm={{ span: isPopup !== true ? 22 : 24, offset: 1 }} xs={{ span: isPopup !== true ? 22 : 24, offset: 1 }}>
                              {singleData && (
                                <Row justify="end" style={{ marginBottom: singleData.photos && singleData.photos.length > 0 ? "-40px" : "0px" }}>
                                  <div>
                                    {singleData && singleData.photos && singleData.photos.length > 0
                                      ? (<ImageGallery photos={singleData && singleData.photos} />) : ""}
                                  </div>
                                </Row>
                              )}
                              <Row className="row-padding">
                                <Card cover={singleData && (<DetailCarsouel photos={singleData && singleData.photos} favorited={singleData && singleData.favorites} />)}>
                                  <div className="homeSearch">
                                    <Layout style={{ backgroundColor: "white" }}>
                                      <Row>
                                        <Col xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 18 }} sm={{ span: 18 }} xs={{ span: 18 }}></Col>
                                        <Col xl={{ span: 4, offset: 4 }} lg={{ span: 5, offset: 3 }} md={{ span: 5, offset: 1 }} sm={{ span: 5, offset: 1 }} xs={{ span: 5, offset: 1 }}>
                                          <div className="row">
                                            {singleData && singleData.vedioLink && (
                                              <div className="column all center-item" onClick={singleData.vedioLink}>
                                                <Popover content={content} trigger="click">
                                                  <div style={{ cursor: "pointer" }}>
                                                    <a href={singleData && singleData.vedioLink && singleData.vedioLink} target="_blank" rel="noreferrer">
                                                      <img src={VedioLink} className="vedioLink" alt="" />
                                                    </a>
                                                  </div>
                                                </Popover>
                                              </div>
                                            )}
                                            {singleData && singleData.DgressLink360 && (
                                              <div className="column all center-item" onClick={singleData.DgressLink360}>
                                                <Popover content={content} trigger="click">
                                                  <div style={{ cursor: "pointer" }}>
                                                    <a href={singleData && singleData.DgressLink360 && singleData.DgressLink360} target="_blank" rel="noreferrer">
                                                      <img src={DegreeLink360} className="vedioLink" alt="" />
                                                    </a>
                                                  </div>
                                                </Popover>
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xl={{ span: 16 }} lg={{ span: 16 }} md={{ span: 18 }} sm={{ span: 18 }} xs={{ span: 18 }}>
                                          <Skeleton title={false} loading={dataLoading} active>
                                            <p className="searchHomes-titles">{singleData && singleData.title}</p>
                                          </Skeleton>
                                        </Col>
                                        <Col xl={{ span: 4, offset: 4 }} lg={{ span: 5, offset: 3 }} md={{ span: 5, offset: 1 }} sm={{ span: 5, offset: 1 }} xs={{ span: 5, offset: 1 }}>
                                          <div className="row">
                                            {singleData && (
                                              <div className="column all center-item" onClick={function() { this.shareThisHome(singleData && singleData.homeId && singleData.homeId); }.bind(this)}>
                                                <Popover content={content} title="Share this Home" trigger="click">
                                                  <div style={{ marginLeft: "2px", marginTop: "4px", cursor: "pointer" }}>
                                                    <ShareAltOutlined className="share" />
                                                  </div>
                                                </Popover>
                                              </div>
                                            )}
                                            {singleData && userLogin && singleData.favorites ? (
                                              <div className="column all center-item">
                                                <DeleteRecord recordId={singleData.favorites} apiPath={"userFavorites"} getHomesList={this.handleDetailsAfterDeleteFav} deletionType={"HeartFilled"} deletionSuccessMessage={"Removed from favorites list"} />
                                              </div>
                                            ) : (
                                              singleData && (
                                                <div className="column all center-item">
                                                  <HeartOutlined className="heart" onClick={function() { userLogin ? this.handleFavorites(singleData) : this.openNotification(); }.bind(this)} />
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                      {singleData && singleData.makePrivateAddress ? (
                                        <>
                                          {singleData && singleData.homeAddress && (
                                            <Row><Col span={24}><Skeleton title={false} loading={dataLoading} active><p className="searchHomes-titles">{singleData && singleData.homeAddress}</p></Skeleton></Col></Row>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {singleData && singleData.address && (
                                            <Row><Col span={24}><Skeleton title={false} loading={dataLoading} active><p className="searchHomes-titles">{singleData && singleData.address}</p></Skeleton></Col></Row>
                                          )}
                                        </>
                                      )}
                                      {singleData && singleData.Labels && (
                                        <Row><Col span={24}><Skeleton title={false} loading={dataLoading} active><p className="font-family-style font-medium-size text-size2 color-grey">{singleData && singleData.Labels}</p></Skeleton></Col></Row>
                                      )}
                                      <Row>
                                        <Skeleton title={false} loading={dataLoading} active>
                                          <p className="font-family-style font-medium-size text-size2 color-grey">
                                            {singleData && singleData.OriginalListprice && singleData.OriginalListprice ? (
                                              <Row><NumberFormat value={parseFloat(singleData && singleData.OriginalListprice).toFixed(2)} displayType={"text"} thousandSeparator={true} prefix={"$"} /></Row>
                                            ) : (
                                              <Row>
                                                <NumberFormat value={parseFloat(singleData && singleData.minPrice).toFixed(2)} displayType={"text"} thousandSeparator={true} prefix={"$"} />{" "}-
                                                <NumberFormat value={parseFloat(singleData && singleData.maxPrice).toFixed(2)} displayType={"text"} thousandSeparator={true} prefix={"$"} />{" "}
                                              </Row>
                                            )}
                                          </p>
                                        </Skeleton>
                                      </Row>
                                      <Row>
                                        <Col style={{ marginRight: "20px" }}>
                                          <img src={bedIcon} alt="space" className="beds-img" />
                                          <span className="searchHomes-subtitles">{singleData && singleData.beds ? singleData.beds : 0} Beds</span>
                                        </Col>
                                        <Col style={{ marginRight: "20px" }}>
                                          <img src={bathIcon} alt="space" className="beds-img" />
                                          <span className="searchHomes-subtitles">{singleData && singleData.baths ? singleData.baths : 0} Baths</span>
                                        </Col>
                                        <Col className="details-area-home" style={{ marginRight: "20px" }}>
                                          <img src={reSize} alt="space" className="beds-img" />
                                          <Skeleton title={false} loading={dataLoading} active className="searchHomes-subtitles">
                                            <span className="searchHomes-subtitles">
                                              {singleData && (singleData.area === null || singleData.area === undefined || singleData.area >= 99999) ? "NA" : "" + (singleData && singleData.area)}
                                            </span>
                                          </Skeleton>
                                        </Col>
                                        <Col>
                                          <EyeOutlined className="searchHomes-subtitles" style={{ fontSize: "17px" }} />
                                          <span className="searchHomes-subtitles">
                                            {singleData.homeAnalyticsData.length && singleData.homeAnalyticsData[0].listingViews ? singleData.homeAnalyticsData[0].listingViews : 0} Views
                                          </span>
                                        </Col>
                                      </Row>
                                    </Layout>
                                  </div>
                                  <Divider style={{ margin: "1%", marginBottom: "20px" }}></Divider>
                                  <Row>
                                    <Space size="large" className="font-family-style font-medium-size size1">
                                      <a href="#description">Description</a>
                                      {singleData && (<a href="#property">Property Details</a>)}
                                      {singleData && (
                                        <>
                                          <a href="#schedule">Schedule a Showing</a>
                                          <a href="#questions">Q&A</a>
                                          <a href="#map">Map</a>
                                        </>
                                      )}
                                      {singleData && window.screen.width >= 500 && (
                                        <>
                                          {((singleData && singleData.OriginalListprice && singleData.OriginalListprice !== "") || (singleData && singleData.maxPrice && singleData.maxPrice !== "")) && (
                                            <div className="desktop-display-detail">
                                              <Mortgage
                                                homePrice={singleData && singleData.OriginalListprice && singleData.OriginalListprice !== "" ? singleData.OriginalListprice : singleData && singleData.maxPrice && singleData.maxPrice !== "" ? singleData.maxPrice : ""}
                                                cityName={singleData && singleData.city}
                                                postalCode={singleData && singleData.zipCode}
                                                stateName={singleData && singleData.state}
                                                detailsPageAds={true}
                                              />
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </Space>
                                  </Row>
                                  {singleData && (
                                    <Row style={{ marginTop: "10px", justifyContent: "space-between" }}>
                                      {((singleData && singleData.OriginalListprice && singleData.OriginalListprice !== "") || (singleData && singleData.maxPrice && singleData.maxPrice !== "")) && (
                                        <div className="mobile-display">
                                          <Mortgage
                                            homePrice={singleData && singleData.OriginalListprice && singleData.OriginalListprice !== "" ? singleData.OriginalListprice : singleData && singleData.maxPrice && singleData.maxPrice !== "" ? singleData.maxPrice : ""}
                                            cityName={singleData && singleData.city}
                                            postalCode={singleData && singleData.zipCode}
                                            stateName={singleData && singleData.state}
                                            detailsPageAds={true}
                                          />
                                        </div>
                                      )}
                                    </Row>
                                  )}
                                </Card>
                              </Row>
                              {singleData && singleData.openHouseStartTime && (
                                <div className="achoreTagClick" id="description">
                                  <Schedule
                                    propertyId={singleData.homeId}
                                    propertyTitle={singleData && singleData.title}
                                    propertyImages={singleData && singleData.photos}
                                    agentId={singleData.userId}
                                    agentName={singleData && singleData.homeAgentName ? singleData.homeAgentName : userDetails.agentName}
                                    agentEmail={singleData && singleData.agentEmail ? singleData.agentEmail : userDetails.agentEmail !== "" && userDetails.agentEmail !== undefined && userDetails.agentEmail !== null ? userDetails.agentEmail : process.env.REACT_APP_AGENT_EMAIL}
                                    mlsAgentId={singleData.agentId}
                                    preferedAgent={loginUserInfo.preferedAgent && loginUserInfo.preferedAgent}
                                    prefereAgentName={loginUserInfo.prefereAgentName && loginUserInfo.prefereAgentName}
                                    getLoginUserInfo={this.getLoginUserInfo}
                                    buyerLoginSendMessage={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? true : false}
                                    showOpenHouseTitle={true}
                                    openHouseStartTime={singleData.openHouseStartTime}
                                    openHouseDesc={singleData.openHouseDescription}
                                    openHouseEndTime={singleData.openHouseEndTime}
                                    listingId={singleData.listingId}
                                    setMlsVendor={this.state.setMlsVendor}
                                  />
                                </div>
                              )}

                              {/* MATCH SCORE + ACCOUNT HOOK BANNERS */}
{singleData && singleData.title && (
  <Row className="row-padding">
    <Col span={24}>
 
      {/* Not logged in: account creation hook */}
      {!userLogin && (
        <div style={{
          background: "linear-gradient(135deg, #2A3390 0%, #1A5C40 100%)",
          borderRadius: "12px",
          padding: "20px 22px",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "12px",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <div style={{ fontSize: "32px" }}>🏡</div>
            <div>
              <div style={{ color: "#D4922A", fontSize: "11px", fontWeight: "800", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "4px" }}>
                My Home Buddha — Healthy · Wealthy · Wise
              </div>
              <div style={{ color: "white", fontSize: "16px", fontWeight: "700", marginBottom: "4px" }}>
                How well does this home match your life?
              </div>
              <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
                Create a free buyer profile to get a personalized match score, commute distance analysis, and AI lifestyle report for every home you view.
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <a
              href="/register"
              style={{
                display: "inline-block", padding: "10px 22px",
                background: "#D4922A", color: "#2c2416",
                borderRadius: "50px", fontWeight: "800", fontSize: "13px",
                textDecoration: "none", whiteSpace: "nowrap",
              }}
            >
              Create Free Account →
            </a>
            <a
              href="/login"
              style={{
                display: "inline-block", padding: "10px 22px",
                background: "transparent", color: "white",
                border: "2px solid rgba(255,255,255,0.6)",
                borderRadius: "50px", fontWeight: "700", fontSize: "13px",
                textDecoration: "none", whiteSpace: "nowrap",
              }}
            >
              Sign In
            </a>
          </div>
        </div>
      )}
 
      {/* Logged in with profile: full match score banner */}
      {userLogin && matchScore && matchScore.hasBuyerProfile && (
        <MatchScoreBanner
                        score={matchScore.total}
                        tier1={matchScore.tier1}
                        tier2={matchScore.tier2}
                        breakdown={matchScore.breakdown}
                        tier2Breakdown={matchScore.tier2Breakdown}
                        hasLifeAddresses={matchScore.hasLifeAddresses}
                        onGetAIAnalysis={this.getAIAnalysis}
                        aiLoading={aiAnalysisLoading}
                        aiResult={aiAnalysisResult}
                        onAddLifeAddresses={this.handleOpenBuyerProfileModal}
                      />
      )}
 
      {/* Logged in but no profile yet: prompt to create */}
      {userLogin && (!matchScore || !matchScore.hasBuyerProfile) && (
        <div style={{
          background: "#f0f4ff",
          border: "1.5px solid #2A3390",
          borderRadius: "12px",
          padding: "16px 20px",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "12px",
        }}>
          <div>
            <div style={{ color: "#2A3390", fontSize: "14px", fontWeight: "700", marginBottom: "4px" }}>
              🎯 Get Your Personalized Match Score
            </div>
            <div style={{ color: "#555", fontSize: "13px" }}>
              Create a buyer profile with your budget, preferred towns, and important life locations (work, schools, activities)
              to see how well this home fits your life — plus an AI lifestyle analysis.
            </div>
          </div>
          <a
            href="/add/buyerform"
            style={{
              display: "inline-block", padding: "10px 22px",
              background: "#2A3390", color: "white",
              borderRadius: "50px", fontWeight: "700", fontSize: "13px",
              textDecoration: "none", whiteSpace: "nowrap",
            }}
          >
            Create Buyer Profile →
          </a>
        </div>
      )}
 
    </Col>
  </Row>
)}
{/* END MATCH SCORE + ACCOUNT HOOK BANNERS */}

                              <div className="achoreTagClick" id="description">
                                <Row className="row-padding">
                                  <Card title="Description / Notes">
                                    <Skeleton title={false} loading={dataLoading} active>
                                      <p className="property-description font-family-style font-normal-size">{singleData && singleData.description}</p>
                                    </Skeleton>
                                  </Card>
                                </Row>
                              </div>
                              <div id="property" className="achoreTagClick">
                                <Row className="row-padding">
                                  <Card title="Property Details">
                                    {card_content.length > 0 && card_content.filter(function(item) { return item.value !== undefined && item.value !== null && item.value !== ""; }).map(function(e) {
                                      return (
                                        <Row style={{ marginBottom: "0.73vw", marginLeft: "0.73vw" }}>
                                          <Col md={10} lg={10} xl={8} sm={12} xs={12}>
                                            <Skeleton title={false} loading={dataLoading} active>
                                              <span className=" font-family-style font-normal-size property-detail-value">{e.name}</span>
                                            </Skeleton>
                                          </Col>
                                          <Col md={14} lg={14} xl={10} sm={12} xs={12}>
                                            <Skeleton title={false} loading={dataLoading} active>
                                              <span className=" font-family-style font-medium-size property-detail-name">{e.value}</span>
                                            </Skeleton>
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                  </Card>
                                </Row>
                              </div>
                              {!beforeLoginLoading && singleData && (
                                <>
                                  {singleData.homeId && (
                                    <Schedule
                                      propertyId={singleData.homeId}
                                      propertyTitle={singleData && singleData.title}
                                      propertyImages={singleData && singleData.photos}
                                      agentId={singleData.userId}
                                      agentName={singleData && singleData.homeAgentName ? singleData.homeAgentName : userDetails.agentName}
                                      agentEmail={singleData && singleData.agentEmail ? singleData.agentEmail : userDetails.agentEmail !== "" && userDetails.agentEmail !== undefined && userDetails.agentEmail !== null ? userDetails.agentEmail : process.env.REACT_APP_AGENT_EMAIL}
                                      mlsAgentId={singleData.agentId}
                                      preferedAgent={loginUserInfo.preferedAgent && loginUserInfo.preferedAgent}
                                      prefereAgentName={loginUserInfo.prefereAgentName && loginUserInfo.prefereAgentName}
                                      getLoginUserInfo={this.getLoginUserInfo}
                                      buyerLoginSendMessage={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? true : false}
                                      showOpenHouseTitle={false}
                                      openHouseStartTime={""}
                                      openHouseEndTime={""}
                                    />
                                  )}
                                  <QuestionAnswers
                                    propertyId={singleData.homeId}
                                    propertyTitle={singleData && singleData.title}
                                    propertyImages={singleData && singleData.photos && singleData.photos.length > 0 ? singleData.photos[0] : []}
                                    agentId={singleData.userId}
                                    agentName={singleData && singleData.homeAgentName ? singleData.homeAgentName : userDetails.agentName}
                                    agentEmail={singleData && singleData.agentEmail ? singleData.agentEmail : userDetails.agentEmail !== "" && userDetails.agentEmail !== undefined && userDetails.agentEmail !== null ? userDetails.agentEmail : process.env.REACT_APP_AGENT_EMAIL}
                                    mlsAgentId={singleData.agentId}
                                    prefereAgentName={loginUserInfo.prefereAgentName && loginUserInfo.prefereAgentName}
                                    preferedAgent={loginUserInfo.preferedAgent && loginUserInfo.preferedAgent}
                                    getLoginUserInfo={this.getLoginUserInfo}
                                    buyerLoginSendMessage={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? true : false}
                                  />
                                  {!beforeLoginLoading && (
                                    <div>
                                      <div id="map" className="achoreTagClick">
                                        <Row>
                                          <Card title="Map">
                                            <Spin spinning={latitude ? false : true}>
                                              {singleData && singleData.makePrivateAddress ? (
                                                <MapComponent lat={parseInt("42.4326041")} lng={parseInt("-71.0557196")} text={this.state.country} />
                                              ) : (
                                                <MapComponent isMarkerShown lat={latitude && latitude} lng={longitude && longitude} text={this.state.country} />
                                              )}
                                            </Spin>
                                          </Card>
                                        </Row>
                                      </div>
                                      <Card title={"Schools in and around " + singleData.city} style={{ marginTop: "2vw" }}>
                                        <Spin spinning={latitude ? false : true}>
                                          {singleData && latitude && longitude && (<MapScore lat={latitude && latitude} lng={longitude && longitude} />)}
                                        </Spin>
                                      </Card>
                                    </div>
                                  )}
                                </>
                              )}
                            </Col>
                            {isPopup !== true && (
                              <Col xl={{ span: 6, offset: 0 }} lg={{ span: 6, offset: 0 }} md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }} className="margin-left-agent">
                                <div>
                                  <>
                                    <Row className="row-padding">
                                      <Card>
                                        <Row className="center-item" style={{ padding: "1%" }}>
                                          <Col>
                                            {singleData && singleData.homeAgentProfileUrl && singleData.homeAgentProfileUrl.length > 0 ? (
                                              <img className="img-detail-page" src={singleData.homeAgentProfileUrl && singleData.homeAgentProfileUrl.length > 0 ? "https://" + process.env.REACT_APP_S3_BUCKET + ".s3.amazonaws.com/public/" + singleData.homeAgentProfileUrl[0] : ""} alt="profileURL" />
                                            ) : singleData.userRegisterd && singleData.userRegisterd.length > 0 ? (
                                              singleData.userRegisterd[0] && (<img className="img-detail-page" src={singleData.userRegisterd[0].profileUrl ? singleData.userRegisterd[0].profileUrl : profilePic} alt="profileURL" />)
                                            ) : (
                                              <img className="img-detail-page" src={profilePic} alt="logo" />
                                            )}
                                          </Col>
                                        </Row>
                                        <Row className="center-item font-family-style font-normal-size profile-name">
                                          <Col className="padding-text-name">
                                            <span className="text-size-name">
                                              {singleData && singleData && singleData.userRegisterd && singleData.userRegisterd.length > 0
                                                ? singleData.userRegisterd[0].firstName + "" + singleData.userRegisterd[0].lastName
                                                : singleData.homeAgentName}
                                            </span>
                                          </Col>
                                        </Row>
                                        <Row className="center-item font-family-style" style={{ paddingTop: "0%", paddingBottom: "1%", marginTop: "-10px" }}>
                                          <p style={{ marginBottom: "0px", fontSize: "16px" }}>{singleData && singleData.companyName}</p>
                                        </Row>
                                        <Row className="center-item">
                                          <Col>
                                            {singleData && singleData.servingName && (<Row className="center-item font-family-style"><p>{singleData && singleData.servingName}</p></Row>)}
                                            {singleData && singleData.userId ? (
                                              <Link style={{ textDecoration: "none", paddingLeft: singleData && singleData.mlsData & 7 }} to={{ pathname: "/viewProfile/" + (singleData && singleData.userid ? singleData.userid : singleData.userId), state: "DetailPage" }} className="profile-view-link">View Profile</Link>
                                            ) : (
                                              singleData && singleData.userRegisterd && singleData.userRegisterd.length > 0 && (
                                                <Link style={{ textDecoration: "none", paddingLeft: "36px" }} to={{ pathname: "/viewProfile/" + (singleData && singleData.userRegisterd && singleData.userRegisterd.length > 0 && singleData.userRegisterd[0].id), state: "DetailPage" }} className="profile-view-link">View Profile</Link>
                                              )
                                            )}
                                            <Row className="center-item"><p className="button-inner-text-size" style={{}}></p></Row>
                                          </Col>
                                        </Row>
                                        <Divider className="divider-detail"></Divider>
                                        {singleData && showSendMessagePopUp && !singleData.mls && (
                                          <Row className="center-item font-family-style" style={{ padding: "3%" }}>
                                            <SendMessage
                                              msgButtonTitle={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? "Share with my Agent" : "Send Message"}
                                              buyerLoginSendMessage={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? true : false}
                                              toName={singleData && singleData.homeAgentName}
                                              propertyId={singleData && singleData.homeId && singleData.homeId}
                                              propertyTitle={singleData && singleData.title ? singleData.title : "enter your message"}
                                              propertyImages={singleData && singleData.photos}
                                              buttonAlign="right"
                                              mlsId={userDetails && userDetails.mlsId}
                                              agentEmail={singleData && singleData.agentEmail}
                                              messageType="potential"
                                              isRegistredUser={this.props.match.params.stateName === "offMls" ? true : false}
                                              stateType={this.props.match.params.stateName}
                                              mlsAgentId={singleData && singleData.agentId}
                                              agentId={singleData.userId}
                                              preferedAgent={loginUserInfo.preferedAgent && loginUserInfo.preferedAgent}
                                              prefereAgentName={loginUserInfo.prefereAgentName && loginUserInfo.prefereAgentName}
                                              getLoginUserInfo={this.getLoginUserInfo}
                                            />
                                          </Row>
                                        )}
                                        {singleData && showSendMessagePopUp && singleData.mls && (
                                          <Row className="center-item font-family-style" style={{ padding: "3%" }}>
                                            <SendMessage
                                              msgButtonTitle={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? "Share with my Agent" : "Send Message"}
                                              buyerLoginSendMessage={loginUserInfo && (loginUserInfo.userProfile === "B" || loginUserInfo.userProfile === "S") ? true : false}
                                              toName={singleData && singleData.homeAgentName && singleData.homeAgentName}
                                              propertyId={singleData && singleData.homeId && singleData.homeId}
                                              propertyTitle={singleData && singleData.title ? singleData.title : "enter your message"}
                                              propertyImages={singleData && singleData.photos}
                                              buttonAlign="right"
                                              mlsId={singleData && singleData.homeId}
                                              agentEmail={singleData && singleData.agentEmail}
                                              messageType="potential"
                                              isRegistredUser={this.props.match.params.stateName === "offMls" ? true : false}
                                              stateType={this.props.match.params.stateName}
                                              mlsAgentId={singleData && singleData.agentId}
                                              agentId={singleData.userId}
                                              preferedAgent={loginUserInfo.preferedAgent && loginUserInfo.preferedAgent}
                                              prefereAgentName={loginUserInfo.prefereAgentName && loginUserInfo.prefereAgentName}
                                              getLoginUserInfo={this.getLoginUserInfo}
                                            />
                                          </Row>
                                        )}
                                        {singleData && (
                                          <Row className="center-item font-family-style" style={{ padding: "3%" }}>
                                            <div style={{ border: "1px solid #FC572B" }}>
                                              <Button type="link" onClick={function() { this.setState({ agentsVisible: true }); }.bind(this)} className="button-inner-text-size" style={{ color: "#FC572B" }}>
                                                Speak to a Buyer's Agent
                                              </Button>
                                            </div>
                                          </Row>
                                        )}
                                      </Card>
                                    </Row>
                                    {userLogin && loginUserInfo && singleData && loginUserInfo.userId === singleData.userId && (
                                      <Row className="row-padding">
                                        <Card bordered={false} headStyle={{ backgroundColor: "darkgray", color: "white" }} bodyStyle={{ backgroundColor: "orange", color: "white", padding: "5px" }} title={"Private Note"}>
                                          <p>{singleData.privateNotes && singleData.privateNotes}</p>
                                        </Card>
                                      </Row>
                                    )}
                                    {singleData && (
                                      <Row className="row-padding">
                                        <Card title="Details">
                                          {details_data.length > 0 && details_data.map(function(e) {
                                            return (
                                              <>
                                                {e.value !== undefined && e.value !== null && e.value !== "" && (
                                                  <>
                                                    <Row style={{ marginBottom: "0.73vw", marginLeft: "0.73vw" }}>
                                                      <Col md={12} lg={24} xl={12} sm={12} xs={12}>
                                                        <span className="font-family-style font-normal-size property-detail-name">{e.name}</span>
                                                      </Col>
                                                      <Col md={12} lg={24} xl={12} sm={12} xs={12}>
                                                        <span className="font-family-style font-normal-size property-detail-value" style={{ fontWeight: "bold" }}>{e.value}</span>
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}
                                              </>
                                            );
                                          })}
                                        </Card>
                                      </Row>
                                    )}
                                    {singleData && singleData && (
                                      <Advertisement otherAds={true} adType="Square" adWhereToShow="Detail" adLimit="10" showMatchesPage={this.props.showMatchesPage} cityName={singleData && singleData.city} postalCode={singleData && singleData.zipCode} stateName={paramsState} detailsPageAds={true} />
                                    )}
                                  </>
                                </div>
                              </Col>
                            )}
                          </Row>
                          {singleData && singleData.homePhotos && (
                            <Row style={{ marginTop: "2vw" }}>
                              {isPopup !== true && (
                                <Card title="Similar Properties">
                                  <Col span={24} style={{ background: " #F9FAFF", paddingBottom: "1vw" }}>
                                    {singleData && singleData.homePhotos && (<HomesCarousel whereToShow="details" limit="20" filterInfo={singleData && singleData} />)}
                                  </Col>
                                </Card>
                              )}
                            </Row>
                          )}
                        </Layout>
                        <Drawer
                          placement="right" title=""
                          width={window.screen.width >= "768" ? "40%" : window.screen.width > "501" && window.screen.width <= "767" ? "80%" : "100%"}
                          mask={true} closable={true} getContainer={false}
                          visible={this.state.enableSignupForm}
                          onClose={function() { this.handleReset(); }.bind(this)}
                          headerStyle={{ textAlign: "center" }}
                          bodyStyle={{ paddingBottom: 80, backgroundColor: "#eff2f5", padding: "0px" }}
                          className="homecard-drawer"
                        >
                          <Row>
                            <Col span={24}>
                              {showLoginSiderForm ? (
                                <LoginForm showAdd={false} modalTrue goTopreviousPage={true} handleToshowLoginSider={this.handletoShowSignupsider} showLoginSiderForm={showLoginSiderForm} questionPage />
                              ) : (
                                <SignupForm questionPage showAdd={false} modalTrue goTopreviousPage={true} handleToshowLoginSider={this.handleToshowLoginSider} showLoginSiderForm={showLoginSiderForm} />
                              )}
                            </Col>
                          </Row>
                        </Drawer>
                      </div>
                    </Col>
                  )}
                </Row>
              </Layout>
            </div>
            <Modal
              className="modal-black-close"
              visible={agentsVisible}
              style={{ marginTop: "2%" }}
              onCancel={function() { this.setState({ agentsVisible: false }); }.bind(this)}
              footer={null}
            >
              <div>
                <Row>
                  <div style={{ marginTop: "20px" }}>
                    <h4>Buyer's Agent</h4>
                    <p style={{ color: "#99A2C3", marginTop: "10px" }}>
                      These local buyers' agents would be happy to represent your interests instead of the seller's interests. Click on profile links to find the best fit for you and send them a message. If no agents are listed or you don't see a good match send a message to our client concierge below and our team of experts will help you find an experienced agent in your area to represent your interests.
                    </p>
                  </div>
                </Row>
                {agentsList && agentsList.length > 0 && agentsList.slice(0, 3).map(function(ownerInfo) {
                  return (
                    <>
                      <BuyerAgentProfile agentInfo={ownerInfo} viewProfileAuth={userLogin ? true : false} propertyId={singleData && singleData.homeId} propertyTitle={singleData && singleData.title} propertyImages={singleData && singleData.photos} />
                      <hr></hr>
                    </>
                  );
                })}
                {contactAgentList && contactAgentList.length > 0 && contactAgentList.slice(0, 1).map(function(agentsInfo) {
                  return (
                    <>
                      <BuyerAgentProfile agentInfo={agentsInfo} viewProfileAuth={userLogin ? true : false} propertyId={singleData && singleData.homeId} propertyTitle={singleData && singleData.title} propertyImages={singleData && singleData.photos} />
                      <hr></hr>
                    </>
                  );
                })}
                {singleData && singleData && (
                  <Row>
                    <Advertisement otherAds={false} adType="Rectangle" adWhereToShow="BuyersAgentPopup" adLimit="1" zipCode={singleData && singleData.zipCode} />
                  </Row>
                )}
              </div>
            </Modal>
          </>
        )}
        {this.state.showBuyerProfileModal && (
          <BuyerProfileModal
            userDetails={JSON.parse(localStorage.getItem("userDetails") || "{}")}
            onComplete={this.handleBuyerProfileModalComplete}
            onDismiss={() => this.setState({ showBuyerProfileModal: false })}
          />
        )}
      </>
    );
  }
}

export default withAppContext(withRouter(Details));
